import { render, staticRenderFns } from "./CreditLimitTable.vue?vue&type=template&id=638b3f18"
import script from "./CreditLimitTable.vue?vue&type=script&lang=ts"
export * from "./CreditLimitTable.vue?vue&type=script&lang=ts"
import style0 from "./CreditLimitTable.vue?vue&type=style&index=0&id=638b3f18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports